/** Line-editing tool names (match web3d line-editing plugin registration). */
export enum DrawingTool {
  Point = 'pointTool',
  CompoundCurve = 'compoundCurve',
  Rectangle = 'threePointRectangleTool',
  Polygon = 'polygonTool',
}

/** Idle/default web3d tool; use to deactivate line-editing tools. */
export const NO_ACTIVE_TOOL = 'selection';
